import { render } from "./CombinationTherapyNew.vue?vue&type=template&id=776135d0&scoped=true"
import script from "./CombinationTherapyNew.vue?vue&type=script&lang=js"
export * from "./CombinationTherapyNew.vue?vue&type=script&lang=js"

import "./CombinationTherapyNew.vue?vue&type=style&index=0&id=776135d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776135d0"],['__file',"src/views/pharmarcy/CombinationTherapyNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "776135d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('776135d0', __exports__)) {
    api.reload('776135d0', __exports__)
  }
  
  module.hot.accept("./CombinationTherapyNew.vue?vue&type=template&id=776135d0&scoped=true", () => {
    api.rerender('776135d0', render)
  })

}


export default __exports__